import React from "react";
import { useLocation } from "react-router-dom";
import { QueryLoader } from "@jsq/ds/core";
import { useGetDocumentUploadInviteDetailsQuery } from "../../../graphql/supergraphHooks";
import { ComplianceCaseTypeEnum } from "../../../graphql/supergraphTypes";
import { useLPComplianceUXv2 } from "../../../hooks/featureFlags";
import { clientContext } from "../../../utils/graphql_utils";
import { ErrorPage } from "../../common/ErrorPage";
import { isStandAloneCase } from "../../utils";
import { DocumentCollectorGuestv1 } from "../DocumentCollectorGuestv1";
import { DocumentCollectorGuestv2 } from "../DocumentCollectorGuestv2";

export const DocumentCollectorGuest = () => {
  const enableLPComplianceUXv2 = useLPComplianceUXv2();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token") as string;

  const documentUploadInviteResult = useGetDocumentUploadInviteDetailsQuery({
    context: clientContext(),
    variables: { emailToken: token },
  });

  const documentUploadInviteDetails =
    documentUploadInviteResult.data?.publicGetDocumentUploadInviteDetails;

  const loadNewUX =
    enableLPComplianceUXv2 ||
    isStandAloneCase(documentUploadInviteDetails?.caseType as ComplianceCaseTypeEnum);

  return (
    <QueryLoader result={documentUploadInviteResult} renderError={() => <ErrorPage />}>
      {loadNewUX ? (
        <DocumentCollectorGuestv2
          documentUploadInviteDetails={documentUploadInviteDetails!}
          token={token}
        />
      ) : (
        <DocumentCollectorGuestv1
          documentUploadInviteDetails={documentUploadInviteDetails!}
          token={token}
        />
      )}
    </QueryLoader>
  );
};
